import React from 'react';
import '../../assets/styles/Pages.css';

const PrivacyPolicy = () => {
  return (
    <div className="page-content">
      <h1>Política de Privacidade</h1>
      
      <p>Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>
      
      <section>
        <h2>1. Introdução</h2>
        <p>Bem-vindo à Calculadora de Juros Compostos. Esta Política de Privacidade explica como coletamos, usamos, divulgamos e protegemos seus dados pessoais quando você utiliza nosso site.</p>
      </section>
      
      <section>
        <h2>2. Informações que Coletamos</h2>
        <p>Podemos coletar as seguintes informações:</p>
        <ul>
          <li><strong>Informações de uso:</strong> dados sobre como você interage com nosso site, incluindo as páginas que você visita e os recursos que usa.</li>
          <li><strong>Informações técnicas:</strong> endereço IP, tipo de navegador, provedor de serviços de Internet, páginas de referência/saída, sistema operacional, data/hora e dados de clickstream.</li>
          <li><strong>Cookies e tecnologias semelhantes:</strong> usamos cookies para melhorar sua experiência em nosso site.</li>
        </ul>
      </section>
      
      <section>
        <h2>3. Como Usamos Suas Informações</h2>
        <p>Usamos as informações coletadas para:</p>
        <ul>
          <li>Fornecer, operar e manter nosso site;</li>
          <li>Melhorar, personalizar e expandir nosso site;</li>
          <li>Entender e analisar como você usa nosso site;</li>
          <li>Desenvolver novos produtos, serviços, recursos e funcionalidades;</li>
          <li>Comunicar-nos com você para fornecer atualizações e outras informações relacionadas ao site;</li>
          <li>Detectar, prevenir e resolver problemas técnicos.</li>
        </ul>
      </section>
      
      <section>
        <h2>4. Publicidade</h2>
        <p>Nosso site utiliza o Google AdSense, um serviço de publicidade fornecido pelo Google. O Google AdSense usa cookies para exibir anúncios com base em suas visitas a este e outros sites. Você pode optar por não participar do uso de cookies do Google AdSense visitando a <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">página de configurações de anúncios do Google</a>.</p>
      </section>
      
      <section>
        <h2>5. Seus Direitos de Privacidade</h2>
        <p>Dependendo da sua localização, você pode ter certos direitos em relação aos seus dados pessoais, incluindo:</p>
        <ul>
          <li>O direito de acessar, atualizar ou excluir as informações que temos sobre você;</li>
          <li>O direito de retificação;</li>
          <li>O direito de oposição;</li>
          <li>O direito de restrição;</li>
          <li>O direito à portabilidade de dados;</li>
          <li>O direito de retirar o consentimento.</li>
        </ul>
      </section>
      
      <section>
        <h2>6. Contato</h2>
        <p>Se você tiver alguma dúvida sobre esta Política de Privacidade, entre em contato conosco pelo e-mail: contato@exemplo.com.br</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;